import { useState } from 'react'

export const useBasketModals = () => {
	const [isAuthModalOpened, setIsAuthModalOpened] = useState(false)

	return {
		isAuthModalOpened,
		openAuthModal: () => setIsAuthModalOpened(true),
		closeAuthModal: () => setIsAuthModalOpened(false)
	}
}
